import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { PRODUCT_LINK_ACTION_TYPE } from "./product-link.action";
import { ProductLinkState } from "./product-link.model";

const INITIAL_STATE: ProductLinkState = {
	content: [],
};

export function productLinkReducer(state = INITIAL_STATE, action: ActionWithPayload): ProductLinkState {
	switch (action.type) {
		case PRODUCT_LINK_ACTION_TYPE.getSuccess: {
			return updateState(state, {
				content: action.payload,
			});
		}
		default:
			return state;
	}
}
